import { openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
import _imports_0 from '@/assets/shinsei_logo2.gif'

const _withId = /*#__PURE__*/_withScopeId("data-v-f2aa2dd6")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("img", {
    class: "logo",
    src: _imports_0,
    alt: "logo",
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleGoToLogin && _ctx.handleGoToLogin(...args)))
  }))
})